/**
 * Composer dictation fallback — POST recorded audio to the server Whisper route.
 *
 *   POST /api/morrow/dictation { audio, language? } -> { text }
 */

import { apiUrl } from "./apiBase";

export function parseDictationTranscript(value: unknown): string {
  if (!value || typeof value !== "object") return "";
  const text = (value as { text?: unknown }).text;
  return typeof text === "string" ? text.trim() : "";
}

export async function blobToDictationBase64(blob: Blob): Promise<string> {
  const dataUrl = await new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result ?? ""));
    reader.onerror = () => reject(reader.error ?? new Error("Could not read dictation audio"));
    reader.readAsDataURL(blob);
  });
  const comma = dataUrl.indexOf(",");
  return comma >= 0 ? dataUrl.slice(comma + 1) : "";
}

export async function transcribeComposerDictation(options: {
  audio: Blob;
  language?: string;
  signal?: AbortSignal;
}): Promise<string> {
  if (options.audio.size === 0) return "";
  const audio = await blobToDictationBase64(options.audio);
  if (audio.length === 0) return "";

  const res = await fetch(apiUrl("/api/morrow/dictation"), {
    method: "POST",
    headers: { accept: "application/json", "content-type": "application/json" },
    body: JSON.stringify({
      audio,
      ...(options.language ? { language: options.language } : {}),
    }),
    ...(options.signal ? { signal: options.signal } : {}),
  });
  if (!res.ok) {
    throw new Error(`Dictation transcription failed (${res.status})`);
  }
  return parseDictationTranscript(await res.json());
}
